import { BeatLoader } from "react-spinners";

const PageLoader = ({ visible }) => {
  if (!visible) return null;
    // const color = getComputedStyle(document.documentElement).getPropertyValue('--primary').trim();
    const color = '231 48% 48%';

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-white/40 z-[9999]">
      <BeatLoader color={`hsl(${color})`} size={10} />
    </div>
  );
};

export default PageLoader;